<template>
    <all-topics type="newest" />
</template>

<script>
import AllTopics from './All'

export default {
    components: { AllTopics },
    name: 'New',
}
</script>
